var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position.show),expression:"position.show"}],ref:"chart",staticClass:"iframe"},[_c('iframe',{staticClass:"frameset",style:({
      width: `calc(100% + 10px)`,
      height: `100%`
    }),attrs:{"frameborder":"0","scrolling":"auto","marginwidth":"0","marginheight":"0","vspace":"0","hspace":"0","allowtransparency":"true","allowfullscreen":"true","src":_vm.option.src,"title":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }